import { __assign } from "tslib";
import React from 'react';
import { PnmacCard, PnmacHtmlToNative } from 'pnmac-universal-components';
import { Platform } from 'react-native';
import BannerView from '../../v2/BannerView';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../../redux/events/events";
//movrWebStatus
var Covid = function (props) {
  var platform = Platform.select({
    web: function () {
      document.openMvr = function () {
        var form = document.createElement("form");
        form.action = props.layout.movr_url;
        form.method = "POST";
        form.target = "_self";
        var input = document.createElement("input");
        input.name = "LoanNumber";
        input.value = props.layout.selectedLoanNumber;
        form.appendChild(input);
        form.style.display = 'none';
        document.body.appendChild(form);
        form.submit();
      };
    }
  });
  var translations = props.translations,
    matches = props.matches,
    movrWebStatus = props.movrWebStatus;
  React.useEffect(function () {
    if (props.layout.selectedLoanNumber > 0) {
      platform();
    }
  }, [props.layout.selectedLoanNumber]);
  return /*#__PURE__*/React.createElement(BannerView, {
    style: {
      marginTop: 0,
      marginBottom: 0,
      marginHorizontal: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, props, {
    onClick: function (e) {
      var target = e.target;
      //alert(e.target.innerHTML);
      if (target != null && (target === null || target === void 0 ? void 0 : target.innerHTML) == "Mortgage Relief") {
        props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Mortgage Relief FAQ from  MOVR Banner Clicked", 0);
        window.windowNav({
          route: "Home/FAQ",
          pageToGoTo: "View_FAQ"
        });
      }
      if (target != null && (target === null || target === void 0 ? void 0 : target.innerHTML) == "click here") {
        props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Web MOVR Banner Clicked", 0);
      }
    },
    value: translations["AssistanceProgram-".concat(movrWebStatus)]
  })));
};
export default Covid;